/* global window document pymChild */

import './styles/graphic.scss';
import * as axios from 'axios';
import { Child } from 'pym.js';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'regenerator-runtime/runtime';

// ////// ENTER URL for data processed by cronbot
const map_data_url = 'https://ix.cnn.io/data/damage-reports/latest.json';

// ////// ENTER details for map styles
const config = {
  style: 'mapbox://styles/cnndigital/ckxkxqrpz381314nod62ol5lw',
  default_zoom: 3.2,
};

// >> ENTER graphic slug, with date ... ie "20210908-stream-flood-tracker"
const graphic_slug = '20211215-damage-reports-live';

// date
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('America/New_York');
dayjs.extend(updateLocale);
dayjs.updateLocale('en', {
  monthsShort: [
    'Enero', 'Feb.', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Ago.', 'Sept.', 'Oct.', 'Nov.', 'Dic.',
  ],
  meridiem: (hour, minute, isLowercase) => (hour >= 12 ? 'p.m.' : 'a.m.'),
});

// Mapbox
const mapboxgl = require('mapbox-gl');

const MAPBOX_TOKEN = 'pk.eyJ1IjoiY25uZGlnaXRhbCIsImEiOiJja2V1M3Vyd3kwMDZrMnF0Njdhb3ZhZDk5In0.OURIYzTcS6ZzoWjXJzfANg';
const defaultCenter = [-95.7129, 39];
let map;
let mapParams;
let hasLocation;


// instantiate pym object
window.pymChild = new Child();

// check for URL params
function checkParams() {
  // use the parent URL if we're using the "parent.html" preview page
  // otherwise use the straight url
  let url;
  if ((pymChild.parentUrl) && (pymChild.parentUrl.indexOf('/parent.html') !== -1)) {
    url = pymChild.parentUrl;
  } else {
    url = window.location.href;
  }

  console.log('Parent url:', pymChild.parentUrl);
  console.log('Using url:', url);

  // Parse params
  const getParams = function (url) {
    const params = {};
    const parser = document.createElement('a');
    parser.href = url;
    const query = parser.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
  };

  mapParams = getParams(url);
  if ('lnglat' in mapParams) {
    mapParams.lnglat = [parseFloat(mapParams.lnglat.split(',')[0]), parseFloat(mapParams.lnglat.split(',')[1])];
  }
  if ('z' in mapParams) {
    mapParams.z = parseFloat(mapParams.z);
  }
  if ('l' in mapParams) {
    mapParams.l = mapParams.l.split(',');
  }

  // Set params to true if they have what we want (zoom + lng/lat)
  hasLocation = !!('lnglat' in mapParams && 'z' in mapParams);
}

export default function (props, container, isMobile, meta) {
  // function to get the latest map data
  const fetchData = async (data_url) => {
    const response = await axios.get(data_url);
    return response.data;
  };

  // function to draw the map
  const drawMap = (mapdata) => {
    const {
      initialWidth,
      initialHeight,
      // width,
      // height
    } = props;


    // // -- make legend -- // //

    // check for "headless" version indicating we're in the special page
    let legend_classes = 'v-legend';
    const q = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(q.entries());
    if (params.headless) {
      legend_classes += ' v-special';
    }

    // // -- legend code -- // //

    const legend_title = 'Profundidad actual de nieve en pulgadas';
    const color_width = 70; // width in pixels
    const breaks = ['1 pulg.', 2, 5, 10, 20, 40, 80, ''];
    if (isMobile) {
      breaks[0] = '1"';
    }
    const colors = ['#ffffff', '#e0ecf4', '#bfd3e6', '#9ebcda', '#8c96c6', '#8c6bb1', '#88419d', '#6e016b', '#ffffff'];

    // assumes a previously-established container div
    container
      .append('div')
      .attr('class', 'v-legend-hed')
      .html(legend_title);

    const map_legend = container
      .append('div')
      .attr('class', 'v-legend-colors-container')
      .attr('width', initialWidth);

    map_legend.selectAll('.v-legend-colors')
      .data(colors)
      .enter()
      .append('div')
      .attr('class', 'v-legend-colors')
      .style('height', '8px')
      .style('width', `${color_width}px`)
      .style('background-color', d => d);

    const map_legend_labels = container
      .append('div')
      .attr('class', 'v-legend-labels-container')
      .attr('width', initialWidth);

    map_legend_labels
      .append('div')
      .attr('class', 'v-legend-label-spacer')
      .style('width', `${color_width / 2}px`);

    map_legend_labels.selectAll('.v-legend-labels')
      .data(breaks)
      .enter()
      .append('div')
      .attr('class', 'v-legend-labels')
      .style('width', `${color_width}px`)
      .html(d => d);

    map_legend_labels
      .append('div')
      .attr('class', 'v-legend-label-spacer')
      .style('width', `${color_width / 2}px`);

    // // -- Map drawing -- // //

    console.log('using cnnvis-cronbot data:', mapdata);

    checkParams();

    // complicated way to adjust the zoom depending on the
    // map size. could use more elegance.
    function getZoom() {
      let zoomLevel;
      if (hasLocation) {
        zoomLevel = isMobile ? mapParams.z - 1 : mapParams.z;
      } else if (initialWidth >= 900) {
        zoomLevel = config.default_zoom + 0.25;
      } else if (initialWidth <= 320) {
        zoomLevel = 2;
      } else {
        zoomLevel = isMobile ? config.default_zoom - 1 : config.default_zoom;
      }
      return zoomLevel;
    }

    // Draw the map
    container.append('div')
      .attr('class', 'map-container')
      .append('div')
      .attr('id', 'map')
      .attr('width', initialWidth)
      .attr('height', initialHeight);

    // // Dynamic footer
    // calculating the fetch date, but then forcing the update time which is always 6am GMT,
    // according to the National Weather Service
    const six_gmt_string = dayjs.utc(mapdata.as_of).format('YYYY-MM-DD[T06:00:00Z]');

    // Then turning 6am GMT this day to ET, which will then account for EST/EDT
    const six_gmt_in_et = dayjs(six_gmt_string).tz('America/New_York').format('D [de] MMM[,] h:mm a [ET] ');
    console.log(six_gmt_in_et);
    container.append('div')
      .attr('class', 'v-dynamic-footnote')
      .html(`&nbsp;<br>${meta.footnote} Datos al ${six_gmt_in_et.trim()}.`);

    mapboxgl.accessToken = MAPBOX_TOKEN;
    map = new mapboxgl.Map({
      container: 'map',
      style: config.style,
      projection: { name: 'albers' },
      center: hasLocation ? mapParams.lnglat : defaultCenter,
      zoom: getZoom(),
      maxZoom: 7,
      minZoom: 2,
      //   Interactive disabled
      pitchWithRotate: false,
      scrollZoom: false,
      dragRotate: false,
      touchPitch: false,
      interactive: true,
    });

    map.on('load', () => {
      // zoom buttons
      const nav = new mapboxgl.NavigationControl({
        showCompass: false,
      });
      map.addControl(nav, 'top-right');

      // ////// LOAD YOUR DATA GEOJSON HERE /////////

      // Force load raster as PNG (Safari will use JPG otherwise) to preserve transparency
      map.addSource('noaa_map', {
        type: 'raster',
        tiles: [
          `https://api.mapbox.com/v4/cnndigital.snow_depth/{z}/{x}/{y}.png?access_token=${mapboxgl.accessToken}`,
        ],
      });

      map.addLayer({
        id: 'raster-layer',
        type: 'raster',
        source: 'noaa_map',
        minzoom: 0,
        maxzoom: 8,
      }, 'jk-us-outline-stroke');
    });


    // /////// THIS PUTS EMBED CODES INTO THE CONSOLE LOG ////////
    // Note that these are removed in the

    map.on('moveend', () => {
      console.log('- - - - - - - - - -');
      const current_lon = map.getCenter().lng;
      const current_lat = map.getCenter().lat;
      const current_zoom = map.getZoom();
      const new_params = `?lnglat=${current_lon},${current_lat}&z=${current_zoom}`;
      console.log('DLE link:');
      console.log(`https://ix.cnn.io/dailygraphics/graphics/${graphic_slug}/index.html${new_params}`);
      console.log('Web tag:');
      console.log(`<div id="responsive-embed-${graphic_slug}"></div>
      <script>
      if(!window.pym){(function(b,c){var d=document.createElement("script");d.type="text/javascript",d.readyState?d.onreadystatechange=function(){("loaded"===d.readyState||"complete"===d.readyState)&&(d.onreadystatechange=null,c())}:d.onload=function(){c()},d.src=b,document.getElementsByTagName("head")[0].appendChild(d)})("//cdn.cnn.com/cnn/.e/interactive/js/lib/vendor/pym/pym.v1.min.js",function(){new pym.Parent("responsive-embed-${graphic_slug}","//ix.cnn.io/dailygraphics/graphics/${graphic_slug}/index.html${new_params}",{title:"CNN Graphic"})})}else var responsiveEmbed=new pym.Parent("responsive-embed-${graphic_slug}","//ix.cnn.io/dailygraphics/graphics/${graphic_slug}/index.html${new_params}",{title:"CNN Graphic"});
      </script>`);
    });

    // update height of svg to pym
    pymChild.sendHeight();
  };

  // clear tile storage to ensure latest data is shown
  // (failure to do this could leave old data in browser for up to 12 hours)
  mapboxgl.clearStorage();

  // fetch data and draw the map
  fetchData(map_data_url).then(drawMap);
}
